import Container from 'react-bootstrap/Container'

import SkeletonLoader from '../../../../components/SkeletonLoader/SkeletonLoader'
import { CINEMA_TYPE } from '../../constants'
import HallDetails from './components/HallDetails/HallDetails'
import MovieDetails from './components/MovieDetails/MovieDetails'

import { useState } from 'react'
import './HallMovie.scss'
import MovieImage from './components/HallImage/MovieImage'

const HallMovie = ({ page, cinemaType = CINEMA_TYPE.DEFAULT, movie, loading = false }) => {
    const [imageLoading, setImageLoading] = useState(true)
    return (
        <Container fluid className={'hall-movie d-flex justify-content-between position-relative'}>
            <SkeletonLoader loading={imageLoading} cx={'movie-poster-loader'}></SkeletonLoader>
            <MovieImage
                className={`movie-poster ${imageLoading ? 'd-none' : ''}`}
                onLoad={() => setImageLoading(false)}
                src={movie?.posterUrl}
                alt={movie?.title_group}
            />
            {cinemaType !== CINEMA_TYPE.DEFAULT && (
                <img
                    src={`images/logo/${cinemaType}.png`}
                    alt={`${cinemaType}`}
                    className={'hall-movie--type-img position-absolute'}
                />
            )}
            <Container fluid className={'hall-movie--details d-flex'}>
                <MovieDetails movie={movie} />
                <HallDetails page={page} movie={movie} cinemaType={cinemaType} />
            </Container>
        </Container>
    )
}

export default HallMovie
